'use client';

import {
  Activity,
  AlertTriangle,
  BarChart3,
  BookOpen,
  GraduationCap,
  Building2,
  CalendarCheck,
  Circle,
  ClipboardList,
  Clock,
  CloudRain,
  DollarSign,
  FileSpreadsheet,
  FileText,
  KanbanSquare,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  Leaf,
  Megaphone,
  MessageSquare,
  MoreHorizontal,
  Package,
  Radio,
  Receipt,
  Route,
  Send,
  Settings,
  ShieldCheck,
  Snowflake,
  Sprout,
  Sparkles,
  Target,
  TrendingUp,
  Truck,
  Users,
  Zap,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Shared Lucide icon map for all navigation chrome (sidebar, bottom bar, More sheet).
 *
 * `lib/platform/navigation/nav-config.ts` references icon keys as plain strings so it stays server-safe.
 * This file is the single mapping from those string keys to Lucide components.
 *
 * Every icon string used in `NAV_PRESETS`, `BOTTOM_BAR_TABS`, or any future nav
 * config MUST be present here. The `nav icon contract` test enforces this.
 */
export const ICON_MAP: Record<string, LucideIcon> = {
  Activity,
  AlertTriangle,
  BarChart3,
  BookOpen,
  GraduationCap,
  Building2,
  CalendarCheck,
  Circle,
  ClipboardList,
  Clock,
  CloudRain,
  DollarSign,
  FileSpreadsheet,
  FileText,
  KanbanSquare,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  Leaf,
  Megaphone,
  MessageSquare,
  MoreHorizontal,
  Package,
  Radio,
  Receipt,
  Route,
  Send,
  Settings,
  ShieldCheck,
  Snowflake,
  Sprout,
  Sparkles,
  Target,
  TrendingUp,
  Truck,
  Users,
  Zap,
};
